export default __webpack_public_path__ + "static/media/footer_bg.a3337f75.jpg";